<form *ngIf="form" [formGroup]="form" class="fields-container">
  <wlm-enhanced-input-select
    [label]="T_SCOPE + '.labels.instance' | translate"
    [options]="instanceOptions"
    [fieldAppearance]="fieldAppearance"
    [fieldClass]="fieldClass"
    floatLabel="always"
    [placeholder]="T_SCOPE + '.placeholders.instance' | translate"
    formControlName="instanceIds"
  >
    <ng-template #option let-optionData let-isSummary="isSummary">
      <tc-mo-connect-form-instance-option
        [label]="optionData.label"
        [instance]="instancesById[optionData.value]"
      ></tc-mo-connect-form-instance-option>
    </ng-template>
  </wlm-enhanced-input-select>

  <wlm-enhanced-input-select
    [label]="T_SCOPE + '.labels.snapshot' | translate"
    [options]="snapshotOptions"
    [fieldAppearance]="fieldAppearance"
    [fieldClass]="fieldClass"
    floatLabel="always"
    [placeholder]="T_SCOPE + '.placeholders.snapshot' | translate"
    formControlName="snapshotIds"
  >
    <ng-template #option let-optionData let-isSummary="isSummary">
      <tc-mo-connect-form-simulation-option
        [snapshot]="snapshotsById[optionData.value]"
        [instance]="instancesById[instanceIdsBySnapshotId[optionData.value]]"
      ></tc-mo-connect-form-simulation-option>
    </ng-template>
  </wlm-enhanced-input-select>

  <wlm-enhanced-input-select
    [label]="T_SCOPE + '.labels.scenario' | translate"
    [options]="scenarioOptions"
    [fieldAppearance]="fieldAppearance"
    [fieldClass]="fieldClass"
    floatLabel="always"
    [placeholder]="T_SCOPE + '.placeholders.scenario' | translate"
    formControlName="scenarioIds"
  >
    <ng-template #option let-optionData let-isSummary="isSummary">
      <tc-mo-connect-form-scenario-option
        [scenario]="scenariosById[optionData.value]"
        [snapshot]="snapshotsById[scenariosById[optionData.value].snapshotId]"
        [instance]="
          instancesById[instanceIdsBySnapshotId[scenariosById[optionData.value].snapshotId]]
        "
      ></tc-mo-connect-form-scenario-option>
    </ng-template>
  </wlm-enhanced-input-select>
</form>
